import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Skeleton, Stack, styled } from '@mui/material';
import useFetch from '../../../../Service/Hooks/useFetch';
import { ApiUrls } from '../../../Utils/globalVariables';


const NavigationtabData = [
    {
        Id: 1,
        Title: "ACT ایالت پایتخت "
    },
    {
        Id: 2,
        Title: "NT قلمرو شمالی"
    },
    {
        Id: 3,
        Title: "NSW نیو ساوت ولز"
    },
    {
        Id: 4,
        Title: "QLD کوئینزلند"
    },
    {
        Id: 5,
        Title: "SA استرالیای جنوبی"
    },
    {
        Id: 6,
        Title: "TAS تاسمانیا"
    },
    {
        Id: 7,
        Title: "VIS ویکتوریا"
    },
    {
        Id: 8,
        Title: "WA استرالیای غربی"
    },
]


export default function DetailTabs({ code }) {
    const [{response, isLoading, error}, doFetch] = useFetch(ApiUrls.GetTerritoryDetail, "get", true)

    React.useEffect(() => {
        if(code) {
            doFetch({id: code})
        }
    }, [code])

    const [value, setValue] = React.useState(0)

    const navWidth = "200px"

    const handleChange = (event, newValue) => {
        setValue(newValue)
    }

    if(code && isLoading) {
        return (
            <Box sx={{ width: '100%', display: {xs: "block", md: "flex"} }}>
                <Box sx={{ width: {xs: "100%", md: `calc(${navWidth})`}, borderBottom: 1, borderColor: 'grey'}}>
                    <CustomTabList orientation="vertical" value={value} onChange={handleChange}>
                        {
                            NavigationtabData.map((val, i) => {
                                return (
                                    <CustomTab key={val.Id} label={
                                        <Stack spacing={1} alignItems="center">
                                            <Typography variant='body1' fontWeight="normal">{val.Title}</Typography>
                                        </Stack>
                                    } />
                                )
                            })
                        }
                    </CustomTabList>
                </Box>
                <Box sx={{width: {xs: "100%", lg: `calc(100% - ${navWidth})`, padding: "0 1rem"}}}>
                <CustomTabPanel value={value} index={0}>
                    <Typography fontSize="20px" fontWeight="bold" sx={{mb: 2}}>{NavigationtabData[0].Title} :</Typography>
                        <Typography textAlign="left" sx={{whiteSpace: "pre-wrap", direction: "ltr !important"}}>
                            {response.act}
                        </Typography>
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={1}>
                        <Typography fontSize="20px" fontWeight="bold" sx={{mb: 2}}>{NavigationtabData[1].Title} :</Typography>
                        <Typography textAlign="left" sx={{whiteSpace: "pre-wrap", direction: "ltr !important"}}>
                            {response.nt}
                        </Typography>
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={2}>
                        <Typography fontSize="20px" fontWeight="bold" sx={{mb: 2}}>{NavigationtabData[2].Title} :</Typography>
                        <Typography textAlign="left" sx={{whiteSpace: "pre-wrap", direction: "ltr !important"}}>
                            {response.nsw}
                        </Typography>
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={3}>
                        <Typography fontSize="20px" fontWeight="bold" sx={{mb: 2}}>{NavigationtabData[3].Title} :</Typography>
                        <Typography textAlign="left" sx={{whiteSpace: "pre-wrap", direction: "ltr !important"}}>
                            {response.qld}
                        </Typography>
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={4}>
                        <Typography fontSize="20px" fontWeight="bold" sx={{mb: 2}}>{NavigationtabData[4].Title} :</Typography>
                        <Typography textAlign="left" sx={{whiteSpace: "pre-wrap", direction: "ltr !important"}}>
                            {response.sa}
                        </Typography>
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={5}>
                        <Typography fontSize="20px" fontWeight="bold" sx={{mb: 2}}>{NavigationtabData[5].Title} :</Typography>
                        <Typography textAlign="left" sx={{whiteSpace: "pre-wrap", direction: "ltr !important"}}>
                            {response.tas}
                        </Typography>
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={6}>
                        <Typography fontSize="20px" fontWeight="bold" sx={{mb: 2}}>{NavigationtabData[6].Title} :</Typography>
                        <Typography textAlign="left" sx={{whiteSpace: "pre-wrap", direction: "ltr !important"}}>
                            {response.vic}
                        </Typography>
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={7}>
                        <Typography fontSize="20px" fontWeight="bold" sx={{mb: 2}}>{NavigationtabData[7].Title} :</Typography>
                        <Typography textAlign="left" sx={{whiteSpace: "pre-wrap", direction: "ltr !important"}}>
                            {response.wa}
                        </Typography>
                    </CustomTabPanel>
                </Box>
            </Box>
        )
    } else if(!isLoading && code) {
        return (
            <Skeleton sx={{width: "100%", height: "160px", my: 3}} variant="rounded" />
        )
    } 
}


//Custom tabs for better navigating
function CustomTabPanel({ children, value, index, ...other }) {

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            {...other}
        >
            {value === index && (
                <Box sx={{ py: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

//Custom tabs
const CustomTabList = styled(Tabs)(
    ({ theme }) => `
        ${theme.breakpoints.down('md')} {
            & .MuiTabs-flexContainer {
                align-items: center !important;
                padding-bottom: 2rem;
            }
        },
        & .MuiTabs-indicator {
            display: none !important;
        }
    `
)

const CustomTab = styled(Tab)(
    ({ theme }) => `
        font-size: ${theme.typography.h3.fontSize};
        text-align: center;
        border-radius: 5px 5px 0 0;
        background: #efefef;
        border: 1px solid #aaaaaa;
        padding: 6px; 
        min-width: 70px;
        transition: 0.4s;
        margin: 0 0.125rem;
        text-transform: initial;
        &.Mui-selected {
            color: white !important;
            background: ${theme.palette.teritiary.main};
        }
        ${theme.breakpoints.down('md')} {
            
            width: 100%;
            
        },
    `
)
